import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentThemeHit as Type } from '../../../../SearchAllContent/types';
import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';

import TaxonomyThemeCard from '../../../../../implementations/Taxonomy/Theme/Card';

const MetaSearchThemeHit: React.FC<{ hit: Type }> = ({ hit }) => (
  <TaxonomyThemeCard
    title={hit.taxonomy_name[0]}
    subtitle={hit.taxonomy_description?.[0]}
    image={(
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['4_3', '3_4', '4_3', '4_3', '4_3'],
          ['md', 'md', 'md', 'md', 'md'],
        )}
        alt=""
        lazyload={false}
      />
    )}
    link={hit.url[0]}
  />
);

export default MetaSearchThemeHit;
